import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../layout/Layout.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/login", name: "Login", component: () => import("../views/Login.vue") },
  {
    path: "/",
    component: Layout,
    redirect: "/ad-slots",
    children: [
      { path: "platform-config", name: "PlatformConfig", component: () => import("../views/platform/PlatformConfig.vue"), meta: { title: "用户分成比例配置" } },
      { path: "referral-config", name: "ReferralConfig", component: () => import("../views/referralConfig/ReferralConfig.vue"), meta: { title: "直推/间推奖励比例配置" } },
      { path: "wx-config", name: "WxConfig", component: () => import("../views/wxConfig/WxConfig.vue"), meta: { title: "微信登录/转账配置" } },
      { path: "ad-slots", name: "AdSlots", component: () => import("../views/adSlot/AdSlotList.vue"), meta: { title: "广告位管理" } },
      { path: "red-packet-config", name: "RedPacketConfig", component: () => import("../views/redPacketConfig/RedPacketConfig.vue"), meta: { title: "红包/福袋配置" } },
      { path: "app-versions", name: "AppVersions", component: () => import("../views/version/VersionManage.vue"), meta: { title: "版本管理" } },
      { path: "users", name: "Users", component: () => import("../views/user/UserList.vue"), meta: { title: "用户管理" } },
      { path: "users/:id", name: "UserDetail", component: () => import("../views/user/UserDetail.vue"), meta: { title: "用户详情" } },
      { path: "withdraws", name: "Withdraws", component: () => import("../views/withdraw/WithdrawList.vue"), meta: { title: "提现申请审核" } },
      { path: "withdraw-config", name: "WithdrawConfig", component: () => import("../views/withdrawConfig/WithdrawConfig.vue"), meta: { title: "提现配置" } },
    ],
  },
];

const router = new VueRouter({ mode: "history", routes });

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("admin_token");
  if (to.path === "/login") {
    next();
  } else if (!token) {
    next("/login");
  } else {
    next();
  }
});

export default router;